import { DBCollection } from '@/lib/utils/constants-shared';
import { BIBLE_BOOKS_SORT_ORDER } from '@/lib/utils/bible-utils';
import { fetchItemsFromDB } from '@/lib/utils/db-service';
import { requireUser } from '@/lib/utils/utils';
import type { Auth } from 'firebase/auth';
import { collection, type Firestore, query, type Timestamp } from 'firebase/firestore';

export async function fetchOutlinesFromDB(auth: Auth, db: Firestore): Promise<Outline[]> {
    const dataQuery = query(collection(db, DBCollection.outlines));
    const items = await fetchItemsFromDB<FirebaseOutline<Timestamp>>(dataQuery);
    return items.map(item => ({
        ...item,
        dateCreated: item.dateCreated.toDate(),
        dateUpdated: item.dateUpdated.toDate()
    }));
}

export function sortOutlines(items: Outline[]): Outline[] {
    return [...items].sort((a, b) => {
        return BIBLE_BOOKS_SORT_ORDER[a.book] < BIBLE_BOOKS_SORT_ORDER[b.book] ? -1 : 1;
    });
}

export function getOutlinesByBook(items: Outline[]): Map<string, Outline[]> {
    const outlinesByBook = new Map<string, Outline[]>();
    items.forEach(item => {
        if (!outlinesByBook.has(item.book)) {
            outlinesByBook.set(item.book, []);
        }
        outlinesByBook.get(item.book)!.push(item);
    });
    return outlinesByBook;
}